import { Schema } from "@generation/core";
import { ClientFactory, ClientHelper } from "@klantondersteuning/client";
import { ICreateKlantcontactEndpointClient } from "@klantondersteuning/client/src/client.generated.klantcontactService";
import { ResponseMapperFormulier, SchemaToRequestMapper } from "@klantondersteuning/shared";
import { RequestInformation } from "../interface/RequestInformation";
import { CakKlantSchemaToRequestMapper } from "../mapper/CakKlantSchemaToRequestMapper";

export class KlantContactService {
  private readonly client: ICreateKlantcontactEndpointClient;
  private readonly schemaToRequestMapper: SchemaToRequestMapper;
  private readonly responseMapper: ResponseMapperFormulier;
  private readonly language: string;
  private readonly formulierKenmerk: string;
  private readonly onderwerp: string;

  constructor(
    apiUrl: string,
    language: string,
    formulierKenmerk: string,
    onderwerp: string,
    schemaToRequestMapper?: SchemaToRequestMapper
  ) {
    const clientFactory = new ClientFactory(apiUrl);
    this.client = clientFactory.getKlantContactEndpointClient();
    this.schemaToRequestMapper = schemaToRequestMapper ?? new CakKlantSchemaToRequestMapper();
    this.responseMapper = new ResponseMapperFormulier();
    this.language = language;
    this.formulierKenmerk = formulierKenmerk;
    this.onderwerp = onderwerp;
  }

  klantContact = async (formulier: any, schemas: Schema[], requestInformation?: RequestInformation) => {
    try {
      const request = await this.schemaToRequestMapper.map(
        schemas,
        formulier,
        this.language,
        this.formulierKenmerk,
        this.onderwerp,
        requestInformation
      );
      const response = await this.client.klantcontacten(undefined, request);
      const result = this.responseMapper.map(response);

      return result;
    } catch (error) {
      return Promise.reject(new Error(ClientHelper.getErrorMessage(error)));
    }
  };
}
